module.exports = __webpack_public_path__ + "img/folder.7c955212.png";